// extracted by mini-css-extract-plugin
module.exports = {"list":"List-module--list--3edFS","rotation":"List-module--rotation--6u5bY","pulse":"List-module--pulse--53Jse"};